import consola from 'consola'

type LogLevel = 'light' | 'verbose'
type LogTypes = 'api' | 'render' | 'cache' | 'all'

interface LogSettings {
  logLevel: LogLevel
  logTypes: LogTypes[]
}

export function logError(message: string, error?: any) {
  const { logLevel } = getLogSettings()

  if (logLevel === 'light')
    console.error(message)
  else if (logLevel === 'verbose')
    console.error(message, error || '')
}

export function logMessage(message: string, { level, type }: { level: LogLevel, type?: LogTypes } = { level: 'verbose', type: undefined }) {
  const { logLevel, logTypes } = getLogSettings()

  if (logLevel === level && (!type || logTypes.includes('all') || logTypes.includes(type)))
    consola.info(message)
}

export function trackTime(startTime = 0) {
  const currentTime = performance.now()
  return currentTime - startTime
}

export function getLogSettings(): LogSettings {
  try {
    const { logLevel, logTypes } = useRuntimeConfig().public
    return { logLevel, logTypes } as unknown as LogSettings
  }
  catch (error) {
    const logLevel = process.env.LOG_LEVEL || 'light'
    const logTypes = process.env.LOG_TYPES ? process.env.LOG_TYPES.split(',') : ['all']

    return { logLevel, logTypes } as unknown as LogSettings
  }
}
